import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { StyledBarContainer } from './app-usage-chart.style'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
    },
};

const labels = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb'];

export const data = {
    labels,
    datasets: [
        {
            data: [0.4, 1.1, 0.8, 1.5, 2.7],
            backgroundColor: '#58B7C2',
        },
    ],
};

const AppUsageChart = () => {
    return (
        <StyledBarContainer>
            <div className="container-top">
                <h3>App Usage</h3>
            </div>
            <div
                style={{ padding: "2rem 1.9rem 1.7rem 2.4rem" }}
            >
                <Bar options={options} data={data} />
            </div>
        </StyledBarContainer>
    )
}

export { AppUsageChart }